"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _socket = _interopRequireDefault(require("socket.io-client"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class SocketIO {
  static open(uri, environment, options = {}) {
    SocketIO.socket = (0, _socket.default)(uri, { ...options
    });
    return SocketIO.socket.on('connect', client => {
      console.log('Client connected');
      SocketIO.client = client;
      SocketIO.socket.emit('environment', environment);
      SocketIO.socket.on('disconnect', () => {
        console.log('Client disconnected');
      });
    });
  }

  static close() {
    SocketIO.socket.close();
  }

  static getClient() {
    return SocketIO.client;
  }

  static getSocket() {
    return SocketIO.socket;
  }

  static on({
    listener,
    callback
  }) {
    SocketIO.socket.on(listener, response => callback(response));
  }

  static emit({
    listener,
    action,
    path,
    method,
    userKey,
    data,
    requestId,
    notification
  }) {
    return SocketIO.socket.emit(listener, {
      action,
      path,
      method,
      userKey,
      data,
      notification,
      requestId
    });
  }

}

exports.default = SocketIO;

_defineProperty(SocketIO, "socket", null);

_defineProperty(SocketIO, "client", null);